module.exports = __webpack_public_path__ + "static/fonts/fontawesome-webfont.c8ddf1e.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.woff?v=4.6.3
 ** module id = 564
 ** module chunks = 1
 **/